'use client';

import React, { useState, useEffect, useCallback } from 'react';
import { TypeAnimation, } from 'react-type-animation';

type TypingEffectProps = {
  children: string;
  typingSpeed?: number;
  word?: boolean;
  useCallback?: boolean;
  fontSize?: string
  className?: string
  style?: React.CSSProperties
};

const TypingEffect: React.FC<TypingEffectProps> = ({ children, typingSpeed = 50, word = false, style, className = '', useCallback = false }) => {

  function wrapTextInSpan() {
    if (!useCallback) {
      return
    }
    // Select the parent container using the selector
    const textContainer = document.querySelector('.textContainer');


    if (textContainer) {
      // Get the inner HTML of the parent
      const text = textContainer.innerHTML;

      // Replace the specified text with the same text wrapped in a span
      let updatedText = text
      if (text.includes('PlaninGo AI!')) {
        updatedText = text.replace(
          'PlaninGo AI!',
          `<span class="bg-ai text-transparent bg-clip-text">${'PlaninGo AI!'}</span>`
        );
      }

      if (text.includes('AI Planner')) {
        updatedText = text.replace(
          'AI Planner',
          `<span class="bg-ai text-transparent bg-clip-text">${'AI Planner'}</span>`
        );
      }
      if (text.includes('Cities')) {
        updatedText = text.replace(
          'Cities',
          `<span class="highlight-purple">${'Cities'}</span>`
        );
      }

      // Update the innerHTML of the parent container with the modified text
      if (typeof updatedText === 'string') {
        textContainer.innerHTML = updatedText;
      }
    }
  }

  return <>
    <TypeAnimation
      key={children}
      splitter={word ? (str) => str.split(/(?= )/) : undefined}
      sequence={[
        // Same substring at the start will only be typed once, initially
        children,
        1000,
        wrapTextInSpan
      ]}
      style={style}
      className={className + ' textContainer'}
      speed={word ? { type: 'keyStrokeDelayInMs', value: typingSpeed } : typingSpeed as any}
    />
  </>
};

export default TypingEffect;
